import { img, thumbImg } from "@/lib/images";

const b = (num: string, caption: string, captionEn: string) => ({
  key: `villas/villa-bougainvillea/villa-bougainvillea-view-${num}.jpg`,
  thumb: thumbImg(`villas/villa-bougainvillea/villa-bougainvillea-view-${num}.jpg`),
  full: img(`villas/villa-bougainvillea/villa-bougainvillea-view-${num}.jpg`),
  caption,
  captionEn,
});

export const bougainvilleaGalleryImages = [
  b("01", "Villa Bougainvillea - Schlafzimmer", "Villa Bougainvillea - Bedroom"),
  b("02", "Villa Bougainvillea - Schlafzimmer", "Villa Bougainvillea - Bedroom"),
  b("03", "Villa Bougainvillea - Schlafzimmer", "Villa Bougainvillea - Bedroom"),
  b("04", "Villa Bougainvillea - Badezimmer", "Villa Bougainvillea - Bathroom"),
  b("05", "Villa Bougainvillea - Terrasse", "Villa Bougainvillea - Terrace"),
  b("06", "Villa Kompiang - Pool", "Villa Kompiang - Pool"),
];